import { createContext } from 'react'

export interface MenuOptions {
  persistent?: boolean
  onClose?: () => void
}

const MenuContext = createContext((_?: JSX.Element, __?: MenuOptions) => { })

export default MenuContext